import { ReactNode } from "react";

import { Fade, Paper, Tab, Tabs, useTheme } from "@mui/material";

export const SliderWrapper = ({
    children,
    isVisible,
}: {
    children: ReactNode;
    isVisible: boolean;
}) => {
    const theme = useTheme();
    return (
        <Fade
            in={isVisible}
            style={{
                transitionDelay: isVisible ? "350ms" : "0ms",
                flex: "0 0 100%",
            }}
            mountOnEnter
            unmountOnExit
        >
            <Paper
                style={{ position: "relative", padding: theme.spacing(5, 2) }}
                elevation={4}
            >
                {children}
            </Paper>
        </Fade>
    );
};

export const Slider = ({
    sections = [],
    tab,
    setTab,
    color = "white",
}: {
    sections: any[];
    tab: number;
    setTab: (tab: number) => void;
    color?: string;
}) => {
    return (
        <section>
            <Tabs
                variant="scrollable"
                scrollButtons="auto"
                value={tab}
                onChange={(_, v) => setTab(v)}
                color={color}
                textColor="secondary"
                indicatorColor="secondary"
                sx={(theme) => ({
                    backgroundColor: "#ebebeb",
                    minHeight: 0,
                    [theme.breakpoints.up("sm")]: {
                        "& .MuiTabs-scroller .MuiTabs-flexContainer": {
                            justifyContent: "center",
                        },
                    },
                })}
            >
                {sections.map((s, i) => (
                    <Tab
                        key={"tab" + i}
                        sx={{
                            paddingTop: 0,
                            paddingBottom: 0,
                            minHeight: 40,
                        }}
                        label={s}
                        color={color}
                    />
                ))}
            </Tabs>
        </section>
    );
};